module.exports = __webpack_public_path__ + "img/고령소비자서비스이미지.fba1c7af.png";